import { type FC, type ReactNode, useCallback } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'

import media from 'styles/media'
import { themes } from 'styles/theme'
import snxTheme from 'styles/theme/colors/snx'

import Login from 'sections/accounts/Login/Login'
import { setOpenModal } from 'state/app/reducer'
import { selectShowModal } from 'state/app/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import WalletDrawer from '../AppLayout/Header/Drawer/WalletDrawer'
import FooterNew from './Footer'
import Header from './Header'

type HomeLayoutProps = {
	marketsMarquee?: boolean
	children: ReactNode
}

const HomeLayout: FC<HomeLayoutProps> = ({ children, marketsMarquee, ...props }) => {
	const openModal = useAppSelector(selectShowModal)
	const dispatch = useAppDispatch()
	const onClose = useCallback(() => dispatch(setOpenModal(null)), [dispatch])

	return (
		<ThemeProvider theme={themes.snx}>
			<Container {...props}>
				<GlobalStyle />
				<Header marketsMarquee={marketsMarquee} />
				<MainContent>{children}</MainContent>
				<FooterNew />
				{openModal === 'sign_in' && <Login onDismiss={onClose} />}
				{openModal === 'manage_wallet' && <WalletDrawer onDismiss={onClose} />}
			</Container>
		</ThemeProvider>
	)
}

const GlobalStyle = createGlobalStyle`
	body {
		overflow-x: hidden;
		background-color: ${snxTheme.darkBackground};
		color: ${snxTheme.text.value};
	}
`

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	overflow: hidden;
`

const MainContent = styled.main`
	flex: 1;
	position: relative;
	padding: 40px;
	overflow: scroll;
	background-color: ${snxTheme.darkBackground};
	border-bottom: ${(props) => props.theme.colors.selectedTheme.landing.border};
	${media.lessThan('lg')`
		padding: 20px;
  `}
`

export default HomeLayout
